import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
emailjs.init("-CWHKxxrs88zxt3w5");

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    childName: '',
    childAge: '',
  });

  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const result = await emailjs.send(
        'service_xjn66zb', // Your EmailJS service ID
        'template_0llr4fr', // Your Contact Us template ID
        {
          name: formData.name,
          message: `Contact Information:
Email: ${formData.email}
Phone: ${formData.phone}

Child's Information:
Name: ${formData.childName}
Age: ${formData.childAge}

Message:
${formData.message}`,
          time: new Date().toLocaleString(),
        }
      );

      if (result.status === 200) {
        setStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: '',
          childName: '',
          childAge: '',
        });
      } else {
        throw new Error('Failed to send email');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setStatus('error');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <section className="card-natural">
        <h1 className="text-4xl font-bold text-clay-500 mb-6">Contact Information</h1>
        <p className="text-earth-400">
          I welcome your interest in my program and look forward to discussing how I can support your child's development. Please use the form below or contact me directly using the information provided.
        </p>
      </section>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <section className="card-natural">
          <h2 className="text-3xl font-bold text-clay-500 mb-6">Program Details</h2>
          <div className="space-y-4 text-earth-400">
            <div>
              <h3 className="text-xl font-semibold text-sage-500 mb-2">Location</h3>
              <p>2713 Webb Road</p>
              <p>Lafayette, New York 13084</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-sage-500 mb-2">Contact Information</h3>
              <p>Primary: (315) 395-6193</p>
              <p>Secondary: (315) 677-8211</p>
              <p>Email: annkatniss@gmail.com</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-sage-500 mb-2">Program Hours</h3>
              <p>Monday - Friday: 7:15 AM - 4:30 PM</p>
              <p>Weekends: Closed</p>
              <p className="mt-2 text-clay-400 font-semibold">
                *A late fee of $1 per minute will be assessed for pick-ups after 4:30 PM*
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-sage-500 mb-2">Additional Resources</h3>
              <p className="mb-2">View my profile on Kinside:</p>
              <a 
                href="https://kinside.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-clay-400 hover:text-clay-500 underline"
              >
                Kinside Profile
              </a>
            </div>
          </div>
        </section>

        <section className="card-natural">
          <h2 className="text-3xl font-bold text-clay-500 mb-6">Enrollment Inquiry</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-earth-400 mb-1">Parent/Guardian Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="input-natural w-full"
                required
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-earth-400 mb-1">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="input-natural w-full"
                required
              />
            </div>
            <div>
              <label htmlFor="phone" className="block text-earth-400 mb-1">Contact Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="input-natural w-full"
                required
              />
            </div>
            <div>
              <label htmlFor="childName" className="block text-earth-400 mb-1">Child's Name</label>
              <input
                type="text"
                id="childName"
                name="childName"
                value={formData.childName}
                onChange={handleChange}
                className="input-natural w-full"
              />
            </div>
            <div>
              <label htmlFor="childAge" className="block text-earth-400 mb-1">Child's Age</label>
              <input
                type="text"
                id="childAge"
                name="childAge"
                value={formData.childAge}
                onChange={handleChange}
                className="input-natural w-full"
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-earth-400 mb-1">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="input-natural w-full h-32"
                required
              />
            </div>
            <button 
              type="submit" 
              className="btn-natural w-full"
              disabled={status === 'sending'}
            >
              {status === 'sending' ? 'Sending...' : 'Submit Inquiry'}
            </button>
            {status === 'success' && (
              <p className="text-sage-500 text-center mt-2">
                Thank you! Your inquiry has been sent successfully.
              </p>
            )}
            {status === 'error' && (
              <p className="text-red-500 text-center mt-2">
                There was an error sending your inquiry. Please try again or contact me directly.
              </p>
            )}
          </form>
        </section>
      </div>

      <section className="card-natural">
        <h2 className="text-3xl font-bold text-clay-500 mb-6">Location</h2>
        <div className="text-center text-earth-400">
          <p className="mb-4">2713 Webb Road, Lafayette, NY 13084</p>
          <a 
            href="https://www.google.com/maps/place/2713+Webb+Rd,+Lafayette,+NY+13084"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-natural inline-block"
          >
            Get Directions
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact; 